

export const runChangeLayout = () => {


  const showWidget = () => {
    const container = document.querySelector('.container-recharge');
    container.classList.remove('hidden-pd');
  }

  const activeReverse = () => {
    const selectorsRecharge = document.querySelector('.rc-radio-group__options');
    selectorsRecharge.classList.add('active-reverse');
  }

  const reloadSelect = () => {
    const label = document.querySelector('input[value="subscription"]');

    label.addEventListener('click', (event) => {
      //console.log('click', event.target);
      setupMutationObserver();
    });
  }

  const loadTag = () => {
    const container = document.querySelector('.discount-label');
    const dataTag = document.querySelector('.container-recharge');

    const { tag } = dataTag.dataset;

    const element = `<label class="discount-tag">${tag}</label>`; 

    container.insertAdjacentHTML('beforeend', element);
  };

  const loadList = () => {
    const cloneElement = document.querySelector('.content-list').cloneNode(true);
    cloneElement.classList.remove('hidden-pd');
    const element = document.querySelector('.rc-selling-plans-dropdown');
    
    element.prepend(cloneElement);
  };

  let mutationObserver;
  
  function loadTextFrequency() {
    const selectOptions = document.querySelectorAll('.js-recharge-select option');
    const dataFrequency = document.querySelector('.container-recharge');
    const { frequency } = dataFrequency.dataset;
    selectOptions.forEach(option => {
      option.textContent = `${frequency} ${option.textContent}`;
    });
  }

  function setupMutationObserver() {
    if (mutationObserver) {
      mutationObserver.disconnect();
    }

    mutationObserver = new MutationObserver(() => {
      const selectElement = document.querySelector('.js-recharge-select');
      if (selectElement) {

        loadTextFrequency();
        loadList();

        mutationObserver.disconnect(); 
      }
    });

    mutationObserver.observe(document.body, { childList: true, subtree: true });
  }


  /* ONE TIME SELECT */

    const run = () => { 
      const container = document.querySelector('.container-recharge');
  
      if (container) {
    
        const inputAll = container.querySelectorAll('.rc-radio__input');
    
        if (inputAll[0].checked) {
          inputAll[1].click();
        } 
        showWidget();
        reloadSelect();
        loadTag()
        setupMutationObserver();
      }
    }

    const mutationObserverLoad = new MutationObserver(() => {
      const selectElement = document.querySelectorAll('.rc-radio__input');
      if (selectElement.length > 0) {
        run();

        mutationObserverLoad.disconnect(); 
      }
    });

    mutationObserverLoad.observe(document.body, { childList: true, subtree: true });

    
  
}